import { useMutation, UseQueryResult } from '@tanstack/react-query'
import { queryClient, QueryOptions, UseMutationResult, useResource, useResources } from '.'
import {
  create,
  fetch,
  get,
  EmployerRule,
  EmployerRuleCreationPayload,
  EmployerRuleUpdatePayload,
  update,
} from '../api/employer-rules'

export const employerRuleKeys = {
  create: ['employer-rules', 'create'] as const,
  update: ['employer-rules', 'update'] as const,
}

//Queries
export const useEmployerRuleQuery = (
  id?: string,
  options?: QueryOptions<EmployerRule>,
): UseQueryResult<EmployerRule, any> =>
  useResource<EmployerRule>('employer-rules', get, id, undefined, options)

export const useEmployerRulesQuery = (
  filters?: {
    employer?: string
    'display.summary'?: boolean
    'display.payroll'?: boolean
    'interval.period'?: EmployerRule['interval']['period']
  },
  options?: QueryOptions<EmployerRule[]>,
): UseQueryResult<EmployerRule[], any> =>
  useResources<EmployerRule[], any>('employer-rules', fetch, filters, options)

//Mutations
const onMutationSuccess = () => {
  queryClient.invalidateQueries(['employer-rules'])
}

export const useCreateMutation = (): UseMutationResult<
  EmployerRule,
  EmployerRuleCreationPayload
> => useMutation(create, { mutationKey: employerRuleKeys.create, onSuccess: onMutationSuccess })

export const useUpdateMutation = (): UseMutationResult<
  EmployerRule,
  EmployerRuleUpdatePayload
> =>
  useMutation(update, {
    mutationKey: employerRuleKeys.update,
    onSuccess: onMutationSuccess,
  })
